import React, { useState, useEffect } from 'react'
import {
  Row,
  Col,
  Button,
  Form,
  Input,
  FormGroup,
  Label,
  ModalBody,
  FormFeedback
} from "reactstrap"
import NumberFormat from 'react-number-format'
import DateTime from 'react-datetime'
import ReactSelect from 'components/Form/Select/Select'
import rest from '../../../lib/rest'
import rotas from '../../../services/rotas'
import Loading from '../../../lib/loading'
import useForm from "../../../lib/useForm"
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Bancos from './bancos'
import moment from 'moment/moment'
import Modal from 'reactstrap/lib/Modal'
import ModalHeader from 'reactstrap/lib/ModalHeader'
import ModalFooter from 'reactstrap/lib/ModalFooter'

const formSwal = withReactContent(Swal)

const FormContas = ({ fechaModal, conta_id, setConta }) => {

  const getMes = () => {
    if (form.id === "") {
      const mes = new Date();
      form.mes_refer = mes.getMonth() + 1;
      return mes.getMonth() + 1;
    } else {
      return (form.mes_refer)
    }

  }

  const getAno = () => {
    if (form.id === "") {
      const ano = new Date();
      form.ano_refer = ano.getFullYear();
      return ano.getFullYear();
    } else {
      return (form.ano_refer);
    }
  }

  const listaMes = [
    { 'id': '1', 'title': '01' },
    { 'id': '2', 'title': '02' },
    { 'id': '3', 'title': '03' },
    { 'id': '4', 'title': '04' },
    { 'id': '5', 'title': '05' },
    { 'id': '6', 'title': '06' },
    { 'id': '7', 'title': '07' },
    { 'id': '8', 'title': '08' },
    { 'id': '9', 'title': '09' },
    { 'id': '10', 'title': '10' },
    { 'id': '11', 'title': '11' },
    { 'id': '12', 'title': '12' },
  ]

  const inicialForm = {
    id: "",
    contas_pagar_id: "",
    banco_id: "",
    centro_custo_id: "",
    favorecido_id: "",
    filial_id: "",
    fornecedor_id: "",
    plano_contas_id: "",
    estabelecimento_id: "",
    cnpj_fornecedor: "",
    contpag_datapag: "",
    contpag_emissao: "",
    contpag_num_doc: "",
    contpag_observ: "",
    contpag_referencia: "",
    contpag_valor: "",
    contpag_valor_antecipado: "",
    contpag_valorpago: "",
    contpag_vencimento: "",
    fantasia: "",
    lojaSelect: [],
    planoContaSelect: [],
    fornecedorSelect: [],
    bancoSelect: [],
    despesa_operacional: "N",
    mes_refer: "",
    mes_referSelec: [],
    ano_refer: "",
    ano_referSelec: [],
    repetir_valor: 'N',
    dividir_valor: 'N',
    valor_recorrencia: {
      id: 0,
      title: ''
    },
    total_prestacao: 0,
    recorrencia: [{
      numDoc: '',
      vencimento: '',
      valor: 0
    }]
  }

  const geraListaAno = () => {
    const data = new Date()
    const mesAtual = data.getMonth() + 1
    const anoAtual = data.getFullYear()

    let lista = []
    for (let i = -1; i <= 5; i++) {
      lista.push({ 'id': anoAtual - i, 'title': anoAtual - i })
    }

    return lista
  }

  const [form, onChange, setForm, onChangeSelect, onChangeDate] = useForm(inicialForm)
  const [listaBanco, setListaBanco] = useState(Bancos)
  const [listaCentroCusto, setListaCentroCusto] = useState([])
  const [listaLoja, setListaLoja] = useState([])
  const [listaPlanoConta, setListaPlanoConta] = useState([])
  const [listaFornecedor, setListaFornecedor] = useState([])
  const [listaFavorecido, setListaFavorecido] = useState([])
  const [listaEstabelecimento, setListaEstabelecimento] = useState([])
  const [loading, setLoading] = useState(true)
  const [tipoFornecedor, setTipoFornecedor] = useState('d-block')
  const [tipoDespesa, setTipoDespesa] = useState('d-none')
  const [classPago, setClassPago] = useState('danger')
  const [listaRecorrencia, setListaRecorrencia] = useState([{ id: '', title: '' }])
  const [loadInicial, setLoadInicial] = useState(true);
  const [refresh, setRefresh] = useState(0);
  const [repetir, setRepetir] = useState([]);
  const [modalPrestacoes, setModalPrestacoes] = useState(false);
  const [disabeldRecorrencia, setDisabledRecorrencia] = useState(true)
  const [classRefAntecipado, setClassRefAntecipado] = useState('');
  const [classRefValor, SetClassRefValor] = useState('');

  const listaLojas = () => {
    let lista = [{ id: 'null', title: 'Nenhum' }]
    const url = rotas.lojas
    try {
      const retorno = rest.get(url)
      retorno.then(ret => {
        // console.log(ret)
        if (ret.success && ret.success == 'S' && ret.lista !== '') {
          for (let i = 0; i < ret.lista.length; i++) {
            lista[i + 1] = { "id": ret.lista[i].filial_id, "title": ret.lista[i].fantasia }
          }
          setListaLoja(lista)
        }
      })
      return (true)
    } catch (err) {
    }
  }

  const listaPlanoContas = () => {
    let lista = [{ id: 'null', title: 'Nenhum' }]
    const url = rotas.planoContas
    try {
      const retorno = rest.get(url)
      retorno.then(ret => {
        // console.log(ret)
        if (ret.success && ret.success == 'S' && ret.lista !== '') {
          for (let i = 0; i < ret.lista.length; i++) {
            lista[i + 1] = { "id": ret.lista[i].plano_contas_id, "title": ret.lista[i].plano_contas }
          }
          setListaPlanoConta(lista)
          // console.log(lista)
        }
      })
      return (true)
    } catch (err) {
    }
  }

  const listaCentroCustos = () => {
    let lista = [{ id: 'null', title: 'Nenhum' }]
    const url = rotas.centroCusto
    try {
      const retorno = rest.get(url)
      retorno.then(ret => {
        // console.log(ret)
        if (ret.success && ret.success == 'S' && ret.lista !== '') {
          for (let i = 0; i < ret.lista.length; i++) {
            lista[i + 1] = { "id": ret.lista[i].centro_custo_id, "title": ret.lista[i].centro_custo }
          }
          setListaCentroCusto(lista)
        }
      })
      return (true)
    } catch (err) {
    }
  }

  const listaFornecedores = () => {
    let lista = [{ id: 'null', title: 'Nenhum' }]
    const url = rotas.fornecedor + "/selectList.php"
    try {
      const retorno = rest.get(url)
      retorno.then(ret => {
        // console.log(ret.lista)
        if (ret.success && ret.success == 'S' && ret.lista !== '') {
          for (let i = 0; i < ret.lista.length; i++) {
            lista[i + 1] = { "id": ret.lista[i].fornecedor_id, "title": ret.lista[i].fornecedor, "cnpj": ret.lista[i].forn_cnpj }
          }
          setListaFornecedor(lista)
        }
      })
      return (true)
    } catch (err) {
    }
  }

  const listaFavorecidos = () => {
    let lista = [{ id: 'null', title: 'Nenhum' }]
    const url = rotas.favorecido
    try {
      const retorno = rest.get(url)
      retorno.then(ret => {
        // console.log(ret.lista)
        if (ret.success && ret.success == 'S' && ret.lista !== '') {
          for (let i = 0; i < ret.lista.length; i++) {
            lista[i + 1] = { "id": ret.lista[i].favorecido_id, "title": ret.lista[i].favorecido }
          }
          setListaFavorecido(lista)
        }
      })
      return (true)
    } catch (err) {
    }
  }

  const listaEstabelecimentos = () => {
    let lista = [{ id: 'null', title: 'Nenhum' }]
    const url = rotas.estabelecimento
    try {
      const retorno = rest.get(url)
      retorno.then(ret => {
        // console.log(ret)
        if (ret.success && ret.success == 'S' && ret.lista !== '') {
          for (let i = 0; i < ret.lista.length; i++) {
            lista[i + 1] = { "id": ret.lista[i].estabelecimento_id, "title": ret.lista[i].estabelecimento }
          }
          setListaEstabelecimento(lista)
        }
      })
      return (true)
    } catch (err) {
    }
  }

  const editContasPagar = (conta_id) => {

    let lista = []
    const url = rotas.contasApagar + '0/' + conta_id
    try {
      const retorno = rest.get(url)
      retorno.then(ret => {
       // console.log(ret.lista[0])
        if (ret.success == 'S' && ret.lista !== '' && ret.lista.length > 0) {
          lista = ret.lista[0]

          lista.lojaSelect = lista.filial_id ? { "id": lista.filial_id, "title": lista.fantasia } : ''
          
          lista.planoContaSelect      = lista.plano_contas_id ? { "id": lista.plano_contas_id, "title": lista.plano_contas } : { "id": 0, "title": '' }
          lista.fornecedorSelect      = lista.fornecedor_id ? { "id": lista.fornecedor_id, "title": lista.fornecedor } : ''
          lista.favorecidoSelect      = lista.favorecido_id     ? { "id": lista.favorecido_id, "title": lista.favorecido } : ''
          lista.estabelecimentoSelect = lista.estabelecimento_id ? { "id": lista.estabelecimento_id, "title": lista.estabelecimento } : ''
          lista.centroCustoSelect     = lista.centro_custo_id ? { "id": lista.centro_custo_id, "title": lista.centro_custo } : ''
          lista.mes_referSelect       = lista.mes_refer ? { "id": lista.mes_refer, "title": lista.mes_refer } : ''
          lista.ano_referSelect       = lista.ano_refer ? { "id": lista.ano_refer, "title": lista.ano_refer } : ''

          const bancoSelect = Bancos.filter((item) => item.id === lista.banco_id)
          lista.bancoSelect = bancoSelect[0]

          lista.contpag_valor = parseFloat(lista.contpag_valor)

          if (lista.contpag_valor_antecipado !== '') {
            lista.contpag_valor_antecipado = parseFloat(lista.contpag_valor_antecipado)
          }
          if (lista.contpag_valorpago !== '') {
            lista.contpag_valorpago = parseFloat(lista.contpag_valorpago)
            if (lista.contpag_valorpago > 0) {
              setClassPago('success')
            }
          }

          if (lista.favorecido_id && lista.favorecido_id != '') {
           // console.log(lista.favorecido_id);
            setTipoFornecedor('d-none')
            setTipoDespesa('d-block')
          }

          setForm(lista)
        }
        setLoading(false)
      })
      return (true)
    } catch (err) {
    }
  }

  useEffect(() => {
    listaLojas()
    listaPlanoContas()
    listaCentroCustos()
    listaFornecedores()
    listaFavorecidos()
    listaEstabelecimentos()

    geraListaAno()

    setLoadInicial(false)

  }, [])

  useEffect(() => {
    if (conta_id != '') {
      editContasPagar(conta_id)
    } else {
      setForm(inicialForm)
      setLoading(false)
    }
  }, [listaPlanoConta])

  useEffect(() => {    
    if ((loadInicial === false) && (loading)) {
      setLoading(false);
    }

  }, [form])

  useEffect(() => {
    let repetir = [];
    let vencimento = moment(form.contpag_vencimento, 'DD/MM/YYYY');
    // console.log(moment(vencimento).format('DD/MM/YYYY'));
    // return

    if (form.repetir_valor === 'S') {

      let cp_valor = form.contpag_valor;

      if (cp_valor.replace) {
        cp_valor = cp_valor.replace('R$ ', '').replace(',', '.');
      }

      for (let x = 1; x <= form.valor_recorrencia.id; x++) {

        vencimento = moment(vencimento).add(30, 'day');

        repetir.push({
          numDoc: form.contpag_num_doc + '-' + (x + 1),
          vencimento: vencimento.format('DD/MM/YYYY'),
          valor: cp_valor
        })
      }

      setRepetir(repetir);
      setModalPrestacoes(true)
    }

    if (form.dividir_valor === 'S') {
      let contpag_valor = form.contpag_valor.replace ?
        form.contpag_valor.replace('R$ ', '').replace(',', '.') :
        form.contpag_valor;

      let valor_prestacao = contpag_valor / form.valor_recorrencia.id;

      for (let x = 1; x <= form.valor_recorrencia.id - 1; x++) {

        vencimento = moment(vencimento).add(30, 'day');

        repetir.push({
          numDoc: form.contpag_num_doc + '-' + (x + 1),
          vencimento: vencimento.format('DD/MM/YYYY'),
          valor: valor_prestacao
        })

      }
      setRepetir(repetir);
      setModalPrestacoes(true);
    }
  }, [form.valor_recorrencia])

  useEffect(() => {
    
    if (form.repetir_valor === 'S') {

      let cp_valor = form.contpag_valor;

      if (cp_valor.replace) {
        cp_valor = cp_valor.replace('R$ ', '').replace(',', '.');
      }

      let total_prestacao = cp_valor * (form.valor_recorrencia.id + 1);

      const frm = form;
      frm.total_prestacao = total_prestacao;
      setForm(frm);
      setRefresh(refresh + 1);
    }

    if (form.dividir_valor === 'S') {
      let novo_contpag_valor = calculaNovoValor();

      let total_prestacao = novo_contpag_valor;

      //let total_prestacao = 0;

      // for(let x = 0; x < repetir.length; x++){
      //   total_prestacao = total_prestacao + repetir[x].valor_prestacao;
      // }

      repetir.map(r => {
        if(r.valor.replace){
          r.valor = r.valor.replace('R$ ','').replace(',','.');
        }
        total_prestacao = total_prestacao + Number(Number(r.valor).toFixed(2));
      })
      //console.log(total_prestacao);
      //total_prestacao = total_prestacao.toFixed(2);  
      const frm = form;

      frm.total_prestacao = total_prestacao.toFixed(2);
      frm.novo_contpag_valor = novo_contpag_valor;
      setForm(frm);
      setRefresh(refresh + 1)
    }
  }, [repetir])

  useEffect(()=>{
    // console.log(form)
    if(form.id !== ""){
      setDisabledRecorrencia(true)
    }else if((form.contpag_num_doc !== '') && (form.contpag_valor !== '')){
      setDisabledRecorrencia(false)
    }else{
      setDisabledRecorrencia(true);
    }
  },[form.id,form.contpag_num_doc,form.contpag_valor])

  const clikRecorrencia = (e) => {
    let check = (e.target.value)

    let retorno = [];

    const frm = form;

    if (check === 'repetir') {
      for (let x = 1; x <= 12; x++) {
        retorno.push({ id: x, title: x + 'x - ' + form.contpag_valor })
      }

      frm.repetir_valor = 'S';
      frm.dividir_valor = 'N';
    }

    if (check === 'dividir') {
      frm.repetir_valor = 'N';
      frm.dividir_valor = 'S';

      for (let x = 2; x <= 12; x++) {
        let valor = form.contpag_valor;

        if (isNaN(valor)) {
          valor = form.contpag_valor.replace('R$ ', '');
          valor = valor.replace(',', '.');
        }

        let valorDividido = valor / x;

        valorDividido = Number(valorDividido).toFixed(2);

        if (valorDividido > 0) {
          retorno.push({ id: x, title: x + 'x - ' + 'R$ ' + valorDividido })
        } else {
          break;
        }
      }
    }

    setListaRecorrencia(retorno);
    setForm(frm);
  }

  const clik_tipoConta = (e) => {
    var check = (e.target.value)
    // console.log(check)
    if (check == "fornecedor") {
      form.favorecido_id = ''
      setTipoDespesa('d-none')
      setTipoFornecedor('d-block')

    } else {
      form.fornecedor_id = ''
      setTipoFornecedor('d-none')
      setTipoDespesa('d-block')
    }
    // console.log(form)
  }

  const cancelarPagamento = () => {

    formSwal.queue([{
      title: 'Deseja cancelar o pagamento da conta ?',
      confirmButtonText: 'SIM',
      showCancelButton: true,
      text: 'Essas informações serão excluidas do banco',
      showLoaderOnConfirm: true,
      cancelButtonColor: '#d33',
      preConfirm: () => {
        // setLoading(true)

        const param = { 'conta_id': conta_id }
        const url = rotas.contasApagar + "cancelarPag.php"
        try {
          const retorno = rest.post(url, param)
          retorno.then(ret => {
            if (ret.success && ret.success == 'S') {
              // editContasPagar(conta_id)
              formSwal.fire('Salvo!', ret.msg, 'success')
              fechaModal()
            } else {
              formSwal.fire('Erro!', ret.msg, 'error')
            }
          })
          return (true)
        } catch (err) {
          console.log(err)
          formSwal.fire('Erro!', err, 'error')
        }
      }
    }])
  }

  const novoCadastro = (e) => {
    setConta('');
    setLoading(true)
    setClassPago('danger')
    setForm(inicialForm)
    //setLoading(false)
  }

  const verificaDiferencaPG = ()=>{
    
    let valorPago       = form.contpag_valorpago;
    let valorOriginal   = form.contpag_valor;
    let valorAntecipado = form.contpag_valor_antecipado;

    if(valorPago.replace){
      valorPago       = valorPago.replace('R$ ','').replace(',','.');
      valorPago = Number(valorPago).toFixed(2);
    }

    if(valorOriginal.replace){
      valorOriginal   = valorOriginal.replace('R$ ','').replace(',','.');
      valorOriginal = Number(valorOriginal).toFixed(2);
    }

    if(valorAntecipado.replace){ 
      valorAntecipado = valorAntecipado.replace('R$ ','').replace(',','.');
      valorAntecipado = Number(valorAntecipado).toFixed(2);
    }

    if((Number(valorPago) > 0)&&
       (Number(valorPago) < Number(valorOriginal))&&
       (Number(valorPago) !== Number(valorAntecipado))){
        
        formSwal.queue([{
          title: 'Confirmação ?',
          confirmButtonText: 'SIM',
          showCancelButton: true,
          text: 'O valor pago é menor do que o valor original, deseja criar uma nova conta a pagar com a diferença de valores?',
          showLoaderOnConfirm: true,
          cancelButtonColor: '#d33',
          preConfirm: () => {

            let repetir = [];
            //let vencimento = moment(form.contpag_vencimento, 'DD/MM/YYYY');
            // console.log(moment(vencimento).format('DD/MM/YYYY'));
            // return
        
            //se houver desconto para antecipacao, confere se nao esta vencido
            //se estiver vencido, zera a variavel valorAntecipado
            if(valorAntecipado > 0){
              let vencimento = moment(form.contpag_vencimento,'DD/MM/YYYY');
              let pagamento  = moment(form.contpag_datapag,'DD/MM/YYYY');

              if(moment(pagamento).isAfter(vencimento)){
                valorAntecipado = 0;                  
              }
            }
            
            let cp_valor =0;

            if(valorAntecipado > 0){
              cp_valor = valorAntecipado - valorPago;
              setClassRefAntecipado('is-valid')
              SetClassRefValor('')
            }else{
              cp_valor = valorOriginal - valorPago;
              setClassRefAntecipado('')
              SetClassRefValor('is-valid')
            }                
            repetir.push({
              numDoc: form.contpag_num_doc + '-1',              
              vencimento: moment(form.contpag_vencimento, 'DD/MM/YYYY').add(30, 'day').format('DD/MM/YYYY'),
              valor: cp_valor
            })

            form.total_prestacao = valorOriginal;
            form.novo_contpag_valor = form.contpag_valorpago;
      
            setRepetir(repetir);
            setModalPrestacoes(true)            
          }
        }])   
    }
  }

  const excluirConta = (e) => {
    if (conta_id != '') {
      //console.log(conta_id)

      formSwal.queue([{
        title: 'Deseja excluir esta conta?',
        confirmButtonText: 'SIM',
        showCancelButton: true,
        text: 'Esta conta será removida permanentemente do banco de dados.',
        showLoaderOnConfirm: true,
        cancelButtonColor: '#d33',
        preConfirm: () => {
          // setLoading(true)
          const param = { 'conta_id': conta_id }
          const url = rotas.contasApagar + '0/' + conta_id
          try {
            const retorno = rest.del(url, param)
            retorno.then(ret => {
              if (ret.success && ret.success == 'S') {
                formSwal.fire('Salvo!', ret.msg, 'success')
                fechaModal()
              } else {
                formSwal.fire('Erro!', ret.msg, 'error')
              }
            })
            return (true)
          } catch (err) {
            formSwal.fire('Erro!', err, 'error')
          }
        }
      }])

    }
  }

  const onChangeRepetir = (e, numDoc) => {
    const rpt = JSON.parse(JSON.stringify(repetir));
    rpt.map(r => {
       if(r.numDoc == numDoc){
         r.valor = e.target.value;
      }
    })
    
    setRepetir(rpt);
    setRefresh(refresh + 1)
  }

  const onChangeRepetirVencimento = (e, numDoc) =>{
    const rpt = repetir;
    rpt.map(r => {
       if(r.numDoc == numDoc){
         r.vencimento = moment(e).format('DD/MM/YYYY');
      }
    })
    setRepetir(rpt);
    setRefresh(refresh + 1)
  }

  const geraNumDoc = () => {
    let dte = new Date();
    let numDoc = '' + dte.getFullYear() + dte.getHours() + dte.getMinutes() + dte.getSeconds();
    const frm = form;
    frm.contpag_num_doc = numDoc;
    setForm(frm);
    setRefresh(refresh + 1);
  }

  const calculaNovoValor = () => {
    let total = 0;

    if (form.contpag_valor.replace) {
      total = form.contpag_valor.replace('R$ ', '').replace(',', '.');
    }
    total = total / form.valor_recorrencia.id;
    return (total);
  }

  const confirmaRecorrencia = () =>{
  
    if((form.dividir_valor === 'S')||(form.novo_contpag_valor)){
      if(form.novo_contpag_valor !== ''){
        form.contpag_valor = form.novo_contpag_valor; 
      }
    }
    setRefresh(refresh + 1);
    setModalPrestacoes(false) 
  }

  const cancelaRecorrencia = () =>{   
    
    setRepetir([]);
    setModalPrestacoes(false); 
  }



  //SUBMIT
  const handleSubmit = (evt) => {
    evt.preventDefault()
    // setLoading(true)
    form.repetir = repetir;

    formSwal.queue([{
      title: 'Deseja salvar ?',
      confirmButtonText: 'Salvar',
      showCancelButton: true,
      text: 'Essas informações serão salvas no banco',
      showLoaderOnConfirm: true,
      cancelButtonColor: '#d33',
      preConfirm: () => {
        //fornecedor ou favorecido
        tipoFornecedor == "d-block" ? form.favorecido_id = '' : form.fornecedor_id = ''
        const url = rotas.contasApagar + 'edit.php'
        
        if (conta_id !== '') {
          return rest.put(url, form)
            .then(ret => {
              if (ret.success == 'S') {
                editContasPagar(conta_id)
                formSwal.fire('Salvo!', ret.msg, 'success')
              } else {
                formSwal.fire('Erro!', ret.msg, 'error')
              }
            })
        } else {
          return rest.post(url, form)
            .then(ret => {
              // console.log(ret)
              if (ret.success == 'S') {
                setConta(ret.conta_id)
                editContasPagar(ret.conta_id)
                formSwal.fire('Salvo!', ret.msg, 'success')
              } else {
                formSwal.fire('Erro!', ret.msg, 'error')
              }
            })
        }
      }
    }])
  }

  if (loading) {
    return (
      <ModalBody className="loadingBody">
        <Loading tipo='componente' />
      </ModalBody>
    )
  } else {
    return (
      <Form onSubmit={handleSubmit}>        
        <Modal
          size={'lg'}
          isOpen={modalPrestacoes}
        >
          <ModalHeader >Confira as Prestações</ModalHeader>
          <ModalBody>            
            {/* conta principal */}
            <Row className={"card-2 border form-check-label"}>
              <Col md={6} className="align-middle">
                <span className={"tag-card bg-secondary text-white"}>Conta Principal</span>
                <FormGroup>
                  <Label for="documento">Nº Documento</Label>
                  <Input
                    required
                    name="documento"
                    id="documento"
                    // type="number"
                    // placeholder="00000"
                    maxLength={20}
                    value={form.contpag_num_doc}
                    readonly
                  // onChange={onChange('contpag_num_doc')}
                  />
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Label for="vencimento-parcela">Data Vencimento</Label>
                  <DateTime
                    id="vencimento-parcela"
                    name="vencimento-parcela"
                    // inputProps    = {{ placeholder: "00/00/0000" }}
                    closeOnSelect={true}
                    dateFormat="DD/MM/YYYY"
                    timeFormat={false}
                    value={form.contpag_vencimento}
                    // onChange={onChangeDate('contpag_vencimento')}
                    inputProps={{
                      // disabled:true,
                      readOnly: true,
                      className: "form-control",
                      placeholder: "__/__/____",
                      onKeyDown: (e) => { e.preventDefault() }
                    }}
                  ></DateTime>
                </FormGroup>
              </Col>

              <Col md={4}>
                <FormGroup>
                  <Label for="valor-parcela">{form.dividir_valor === 'S' ? 'Novo Valor' : 'Valor'}</Label>
                  <NumberFormat
                    // required
                    
                    name="valor-parcela"
                    id="valor-parcela"
                    placeholder="0.00"
                    value={form.dividir_valor === 'S' ? form.novo_contpag_valor : form.contpag_valor}
                    //value={form.novo_contpag_valor}
                    // value={(form.contpag_valor.replace ? 
                    //         form.contpag_valor.replace('R$ ','').replace(',','.') : 
                    //         form.contpag_valor) / form.valor_recorrencia.id}
                    // onChange={onChange('contpag_valor_antecipado')}
                    maxLength={20}
                    decimalScale={2}
                    allowNegative={false}
                    className={"form-control " + classRefValor}
                    prefix={"R$ "}
                    // thousandSeparator={true}
                    decimalSeparator={','}
                    fixedDecimalScale
                    isAllowed={false}
                  />
                </FormGroup>
              </Col>

              <Col md={4}>
                <FormGroup>
                  <Label for="valor-antecipado">{'Valor se Antecipado'}</Label>
                  <NumberFormat
                    // required
                    name="valor-parcela"
                    id="valor-parcela"
                    placeholder="0.00"
                    value={form.contpag_valor_antecipado}
                    //value={form.novo_contpag_valor}
                    // value={(form.contpag_valor.replace ? 
                    //         form.contpag_valor.replace('R$ ','').replace(',','.') : 
                    //         form.contpag_valor) / form.valor_recorrencia.id}
                    // onChange={onChange('contpag_valor_antecipado')}
                    maxLength={20}
                    decimalScale={2}
                    allowNegative={false}
                    className={"form-control " + classRefAntecipado}
                    prefix={"R$ "}
                    // thousandSeparator={true}
                    decimalSeparator={','}
                    fixedDecimalScale
                    isAllowed={false}
                  />
                </FormGroup>
              </Col>

              <Col md={4} hidden={false}>
                <FormGroup>
                  <Label for="novo-valor-conta">{'Novo Valor'}</Label>
                  <NumberFormat
                    // required
                    name="valor-parcela"
                    id="valor-parcela"
                    placeholder="0.00"         
                    value={form.novo_contpag_valor}
                    //value={form.novo_contpag_valor}
                    // value={(form.contpag_valor.replace ? 
                    //         form.contpag_valor.replace('R$ ','').replace(',','.') : 
                    //         form.contpag_valor) / form.valor_recorrencia.id}
                    // onChange={onChange('contpag_valor_antecipado')}
                    maxLength={20}
                    decimalScale={2}
                    allowNegative={false}
                    className={"form-control disabledCampo"}
                    prefix={"R$ "}
                    disabled
                    // thousandSeparator={true}
                    decimalSeparator={','}
                    fixedDecimalScale
                    isAllowed={false}
                  />
                </FormGroup>
              </Col>

              
            </Row>

            {/* repeticao das parcelas */}

            {repetir.map(p =>

              <Row>
                <Col>
                  <FormGroup>
                    <Label for="documento">Nº Documento</Label>
                    <Input
                      required
                      name="documento"
                      id="documento"
                      // type="number"
                      // placeholder="00000"
                      maxLength={20}
                      value={p.numDoc}
                      //onChange={onChange('contpag_num_doc')}
                    />
                  </FormGroup>
                </Col>

                <Col>
                  <FormGroup>
                    <Label for="valor-parcela">Valor</Label>
                    <NumberFormat
                      // required
                      name="valor-parcela"
                      id="valor-parcela"
                      placeholder="0.00"
                      // value       = {form.contpag_valor_antecipado ? form.contpag_valor_antecipado.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}):''}
                      value={p.valor.replace ? p.valor.replace('.', ',') : p.valor}
                      onChange={(e) => { onChangeRepetir(e, p.numDoc) }}
                      maxLength={20}
                      decimalScale={2}
                      allowNegative={false}
                      className={"form-control"}
                      prefix={"R$ "}
                      // thousandSeparator={true}
                      decimalSeparator={','}
                      fixedDecimalScale
                      readOnly={form.repetir_valor === 'S' ? true : false}
                    />
                  </FormGroup>
                </Col>

                <Col>
                  <FormGroup>
                    <Label for="vencimento-parcela">Data Vencimento</Label>
                    <DateTime
                      id="vencimento-parcela"
                      name="vencimento-parcela"
                      // inputProps    = {{ placeholder: "00/00/0000" }}
                      closeOnSelect={true}
                      dateFormat="DD/MM/YYYY"
                      timeFormat={false}
                      value={p.vencimento}
                      onChange={(e) => { onChangeRepetirVencimento(e, p.numDoc) }}
                      inputProps={{
                        // disabled:true,
                        // readOnly: true,
                        className: "form-control",
                        placeholder: "__/__/____",
                        onKeyDown: (e) => { e.preventDefault() }
                      }}
                    ></DateTime>
                  </FormGroup>
                </Col>
              </Row>
            )}

            <Row>
              <Col>
                <FormGroup>
                  <Label for="total-parcela">Total</Label>
                  <NumberFormat
                    // required
                    name="total-parcela"
                    id="total-parcela"
                    placeholder="0.00"
                    value={form.total_prestacao ? (form.total_prestacao.replace ? form.total_prestacao.replace('.', ',') : form.total_prestacao) : '0'}
                    maxLength={20}
                    decimalScale={2}
                    allowNegative={false}
                    className={"form-control disabledCampo"}
                    prefix={"R$ "}
                    isAllowed={false}
                    // thousandSeparator={true}
                    decimalSeparator={','}
                    fixedDecimalScale                    
                  />
                  {/* <Input
                    required
                    name="documento"
                    id="documento"                    
                    maxLength={20}                  
                    value={form.total_prestacao ? form.total_prestacao : ''}
                    readOnly                    
                  /> */}
                </FormGroup>
              </Col>
            </Row>

          </ModalBody>
          <ModalFooter className='d-flex justify-content-center'>
            
              <Button 
                color="success" 
                onClick={confirmaRecorrencia} >Confirmar
              </Button>{' '}
              
              <Button 
                color="secondary" 
                onClick={cancelaRecorrencia} >Cancelar
              </Button>

          </ModalFooter>
        </Modal>

        <Row className="card-2">
          <Col>
            <span className="tag-card">Tipo de conta</span>
            <FormGroup className="mb-0">
              <Row>
                <div className="form-check-radio mb-0 mr-3">
                  <Label className="form-check-label">
                    <Input
                      type="radio"
                      id="tipoFornecedor"
                      name="tipo"
                      value="fornecedor"
                      onClick={clik_tipoConta}
                      defaultChecked={form.fornecedor_id ? true : false}
                    />
                    Fornecedor
                    <span className="form-check-sign"></span>
                  </Label>
                </div>

                <div className="form-check-radio mb-0">
                  <Label className="form-check-label">
                    <Input
                      type="radio"
                      id="tipoDespesa"
                      name="tipo"
                      value="despesa"
                      onClick={clik_tipoConta}
                      defaultChecked={form.favorecido_id ? true : false}
                    />
                    Despesa
                    <span className="form-check-sign"></span>
                  </Label>
                </div>

                {/* <Col className="p-0 ml-5" md="0">
                  <FormGroup className="m-0" check>
                    <Label style={{ paddingLeft: '30px' }} check>
                      <Input
                        type="checkbox"
                        id="despesa_operacional"
                        name="despesa_operacional"
                        label="Despesa Operacional"
                        checked={form.despesa_operacional == 'S' ? true : false}
                        onChange={onChange('despesa_operacional')}
                      />
                      <span className="form-check-sign" />Despesa Operacional
                    </Label>
                  </FormGroup>
                </Col> */}

              </Row>
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col>
            <FormGroup>
              <ReactSelect
                required
                name="loja"
                label="Loja"
                placeholder="Selecione loja"
                options={listaLoja}
                defaultValue={form.lojaSelect}
                onChange={onChangeSelect('lojaSelect')}
                onClick={form.lojaSelect ? form.filial_id = form.lojaSelect.id : ''}
              >
              </ReactSelect>
            </FormGroup>
          </Col>

          <Col>
            <FormGroup>
              <ReactSelect
                required
                name="planoConta"
                label="Plano de Conta"
                placeholder="Selecione plano de conta"
                options={listaPlanoConta}
                defaultValue={form.planoContaSelect}
                onChange={onChangeSelect('planoContaSelect')}
                onClick={form.planoContaSelect ? form.plano_contas_id = form.planoContaSelect.id : ''}
                className='rounded border border-warning'
              >
              </ReactSelect>
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <ReactSelect
                required
                name="centroCusto"
                label="Centro de Custo"
                placeholder="Selecione centro de custo"
                options={listaCentroCusto}
                defaultValue={form.centroCustoSelect}
                onChange={onChangeSelect('centroCustoSelect')}
                onClick={form.centroCustoSelect ? form.centro_custo_id = form.centroCustoSelect.id : ''}
              >
              </ReactSelect>
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md="4">
            <FormGroup className={tipoFornecedor}>
              <ReactSelect
                required
                name="fornecedor"
                label="Fornecedor"
                placeholder="Selecione fornecedor"
                options={listaFornecedor}
                defaultValue={form.fornecedorSelect}
                onChange={onChangeSelect('fornecedorSelect')}
                onClick={form.fornecedorSelect ? form.fornecedor_id = form.fornecedorSelect.id : ''}
                disabled={tipoFornecedor}
                className='rounded border border-warning'
              >
              </ReactSelect>
            </FormGroup>

            <FormGroup inline className={'inline ' + tipoDespesa}>
              <ReactSelect
                required
                name="favorecido"
                label="Favorecido"
                placeholder="Selecione favorecido"
                options={listaFavorecido}
                defaultValue={form.favorecidoSelect}
                onChange={onChangeSelect('favorecidoSelect')}
                onClick={form.favorecidoSelect ? form.favorecido_id = form.favorecidoSelect.id : ''}
                disabled={tipoDespesa}
                className='rounded border border-warning'
              >
              </ReactSelect>
              {/* <Col>
              <Button type='button' className="btn-icon">
                <i className="fa fa-plus" />
              </Button>
            </Col> */}
            </FormGroup>
          </Col>

          <Col md="4">
            <FormGroup>
              <ReactSelect
                required
                name="Estabelecimento"
                label="Estabelecimento"
                placeholder="Selecione o estabelecimento"
                options={listaEstabelecimento}
                defaultValue={form.estabelecimentoSelect}
                onChange={onChangeSelect('estabelecimentoSelect')}
                onClick={form.estabelecimentoSelect ? form.estabelecimento_id = form.estabelecimentoSelect.id : ''}
                className='rounded border border-warning'
              >
              </ReactSelect>
            </FormGroup>
          </Col>

          <Col  md="2" className="d-flex">
            <FormGroup>
              <Label for="documento">Nº Documento</Label>
              <Input
                required
                name="documento"
                id="documento"
                // type="number"
                // placeholder="00000"
                maxLength={20}
                value={form.contpag_num_doc}
                onChange={onChange('contpag_num_doc')}
              />
            </FormGroup>            
          </Col>

          <Col md="2" className="d-flex pt-3">
            <Button
              hidden={form.contas_pagar_id !== "" ? true : false}
              // style={{backgroundColor:'#b6b6b6'}}
              color="warning"
              block

              onClick={geraNumDoc}
            >Gerar Nº</Button>
          </Col>
        </Row>

        <Row>
          <Col>
            <FormGroup>
              <Label for="valor">Valor</Label>
              <NumberFormat
                required
                name="valor"
                id="valor"
                placeholder="0.00"
                // value     = {form.contpag_valor ? form.contpag_valor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}):''}
                value={form.contpag_valor}
                onChange={onChange('contpag_valor')}
                maxLength={20}
                decimalScale={2}
                allowNegative={false}
                className={"form-control"}
                prefix={"R$ "}
                // thousandSeparator={true}
                decimalSeparator={','}
                fixedDecimalScale
              />
            </FormGroup>
          </Col>

          <Col>
            <FormGroup>
              <Label for="antecipado">Valor se Antecipado</Label>
              <NumberFormat
                // required
                name="antecipado"
                id="antecipado"
                placeholder="0.00"
                // value       = {form.contpag_valor_antecipado ? form.contpag_valor_antecipado.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}):''}
                value={form.contpag_valor_antecipado}
                onChange={onChange('contpag_valor_antecipado')}
                maxLength={20}
                decimalScale={2}
                allowNegative={false}
                className={"form-control"}
                prefix={"R$ "}
                // thousandSeparator={true}
                decimalSeparator={','}
                fixedDecimalScale
              />
            </FormGroup>
          </Col>

          <Col>
            <FormGroup>
              <Label for="emissao">Data Emissão</Label>
              <DateTime
                id="emissao"
                name="emissao"
                // inputProps    = {{ placeholder: "00/00/0000" }}
                closeOnSelect={true}
                dateFormat="DD/MM/YYYY"
                timeFormat={false}
                value={form.contpag_emissao}
                onChange={onChangeDate('contpag_emissao')}
                inputProps={{
                  // disabled:true,
                  // readOnly: true,
                  className: "form-control",
                  placeholder: "__/__/____",
                  onKeyDown: (e) => { e.preventDefault() }
                }}
              ></DateTime>
            </FormGroup>
          </Col>

          <Col>
            <FormGroup>
              <Label for="vencimento">Data Vencimento</Label>
              <DateTime
                id="vencimento"
                name="vencimento"
                // inputProps    = {{ placeholder: "00/00/0000" }}
                closeOnSelect={true}
                dateFormat="DD/MM/YYYY"
                timeFormat={false}
                value={form.contpag_vencimento}
                onChange={onChangeDate('contpag_vencimento')}
                inputProps={{
                  // disabled:true,
                  // readOnly: true,
                  className: "form-control",
                  placeholder: "__/__/____",
                  onKeyDown: (e) => { e.preventDefault() }
                }}
              ></DateTime>
            </FormGroup>
          </Col>

          <Col>
            <FormGroup>
              <ReactSelect
                required
                name="Mês Referência"
                label="Mês Referência"
                placeholder="Mês"
                options={listaMes}
                //defaultValue={form.mes_referSelect}
                defaultValue={{ id: getMes(), title: getMes() }}
                onChange={onChangeSelect('mes_referSelect')}
                onClick={form.mes_referSelect ? form.mes_refer = form.mes_referSelect.id : ''}
              >
              </ReactSelect>
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <ReactSelect
                required
                name="Ano Referência"
                label="Ano Referência"
                placeholder="Ano"
                options={geraListaAno()}
                //defaultValue={form.ano_referSelect}
                defaultValue={{ id: getAno(), title: getAno() }}
                onChange={onChangeSelect('ano_referSelect')}
                onClick={form.ano_referSelect ? form.ano_refer = form.ano_referSelect.id : ''}
              >
              </ReactSelect>
            </FormGroup>
          </Col>
        </Row>

        <Row
          className={"card-2 border form-check-label"}
        >
          <Col className="align-middle">
            <span className={"tag-card bg-secondary text-white"}>Recorrência</span>
            <div className="form-check-radio mb-0 mr-3">
              <Label className="form-check-label">
                <Input
                  type="radio"
                  id="tipo-recorrencia"
                  name="tipo-recorrencia"
                  value="repetir"
                  onClick={clikRecorrencia}
                  // disabled={form.id != "" ? true : false}
                  disabled = {disabeldRecorrencia}
                //defaultChecked={form.fornecedor_id ? true : false}
                />
                Repetir Valor
                <span className="form-check-sign"></span>
              </Label>
            </div>

            <div className="form-check-radio mb-0">
              <Label className="form-check-label">
                <Input
                  type="radio"
                  id="tipo-recorrencia"
                  name="tipo-recorrencia"
                  value="dividir"
                  onClick={clikRecorrencia}
                  disabled = {disabeldRecorrencia}
                  //disabled={form.id != "" ? true : false}
                //defaultChecked={form.favorecido_id ? true : false}
                />
                Dividir Valor
                <span className="form-check-sign"></span>
              </Label>
            </div>
          </Col>
          <Col>
            <FormGroup>
              <ReactSelect
                required
                name="repetir-valor"
                label=" "
                placeholder="Selecione"
                options={listaRecorrencia}
                //defaultValue={form.mes_referSelect}
                onChange={onChangeSelect('valor_recorrencia')}
                //onClick={form.mes_referSelect ? form.mes_refer = form.mes_referSelect.id : ''}
                isDisabled = {disabeldRecorrencia}
                //isDisabled={form.id != "" ? true : false}
              >
              </ReactSelect>
            </FormGroup>
          </Col>
        </Row>

        <Row className={"card-2 border border-" + classPago}>
          <Col md="6">
            <span className={"tag-card bg-" + classPago + " text-white"}>Dados do pagamento</span>
            <FormGroup>
              <ReactSelect
                // required
                name="banco"
                label="Banco"
                placeholder="Selecione o banco"
                options={listaBanco}
                defaultValue={form.bancoSelect}
                onChange={onChangeSelect('bancoSelect')}
                onClick={form.bancoSelect ? form.banco_id = form.bancoSelect.id : ''}
              >
              </ReactSelect>
            </FormGroup>
          </Col>

          <Col>
            <FormGroup>
              <Label for="pagamento">Data Pagamento</Label>
              <DateTime
                id="pagamento"
                name="pagamento"
                // inputProps    = {{ placeholder: "00/00/0000" }}
                closeOnSelect={true}
                dateFormat="DD/MM/YYYY"
                timeFormat={false}
                value={form.contpag_datapag}
                onChange={onChangeDate('contpag_datapag')}
                inputProps={{
                  // disabled:true,
                  // readOnly: true,
                  className: "form-control",
                  placeholder: "__/__/____",
                  onKeyDown: (e) => { e.preventDefault() }
                }}
              ></DateTime>
            </FormGroup>
          </Col>

          <Col>
            <FormGroup>
              <Label for="pago">Valor Pago</Label>
              <NumberFormat
                // required
                name="pago"
                id="pago"
                placeholder="0.00"
                // value       = {form.contpag_valorpago ? form.contpag_valorpago.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}):''}
                value={form.contpag_valorpago}
                onChange={onChange('contpag_valorpago')}
                onBlur={verificaDiferencaPG}
                maxLength={20}
                decimalScale={2}
                allowNegative={false}
                className={"form-control"}
                prefix={"R$ "}
                // thousandSeparator={true}
                decimalSeparator={','}
                fixedDecimalScale
              />
            </FormGroup>
          </Col>

          <Col className={classPago == 'success' ? "d-block" : "d-none"}>
            <Button type="button" className="mb-0 mt-3" color="danger" size="md" onClick={() => cancelarPagamento()}>
              Cancelar Pagamento
            </Button>
          </Col>
        </Row>

        <FormGroup>
          <Label for="pago">Observações</Label>
          <Input
            className="form-control"
            type="textarea"
            name="observacao"
            id="observacao"
            placeholder="Digite aqui sua observação sobre essa conta a pagar..."
            value={form.contpag_observ ?? ''}
            onChange={onChange('contpag_observ')}
            maxLength={200}
          />
        </FormGroup>

        <Col className="text-center p-3">
          <Button type="button" className="mb-0 mt-0" color="info" size="md" onClick={() => novoCadastro()}>
            <i className="fas fa-plus" /> Cadastro
          </Button>
          <Button type="submit" className="mb-0 mt-0" color="success" size="md" >
            Salvar
          </Button>
          <Button type="button" className="mb-0 mt-0" color="danger" size="md" onClick={() => excluirConta()}>
            Excluir
          </Button>
          <Button type="button" className="mb-0 mt-0" color="default" size="md" onClick={() => fechaModal()}>
            Fechar
          </Button>
        </Col>
      </Form>
    )
  }

}

export default FormContas;